import { render, staticRenderFns } from "./Acrescimo.vue?vue&type=template&id=0ca5113c"
import script from "./Acrescimo.vue?vue&type=script&lang=js"
export * from "./Acrescimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports